import { OrderPageData } from '../api/models/OrderPageData';

/**
 * Gets the primary photo URL from an order page.
 * First checks order_page_images (returns the one with lowest order value),
 * then falls back to the legacy photo field.
 */
export function getPrimaryPhoto(orderPage: OrderPageData | null | undefined): string | undefined {
  if (orderPage?.order_page_images?.length) {
    return [...orderPage.order_page_images].sort((a, b) => a.order - b.order)[0]?.value;
  }
  return undefined;
}

export function optimizeImageUrl(url: string | undefined, maxWidth: number): string | undefined {
  if (!url) return undefined;
  if (!url.includes('upcdn.io')) return url;
  const optimized = url.includes('/raw/') ? url.replace('/raw/', '/image/') : url;
  return `${optimized}${optimized.includes('?') ? '&' : '?'}w=${maxWidth}`;
}
